import { render, staticRenderFns } from "./ViewTin.vue?vue&type=template&id=5ea98205&scoped=true"
import script from "./ViewTin.vue?vue&type=script&lang=js"
export * from "./ViewTin.vue?vue&type=script&lang=js"
import style0 from "./ViewTin.vue?vue&type=style&index=0&id=5ea98205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea98205",
  null
  
)

export default component.exports